import { render, staticRenderFns } from "./BankSlip.vue?vue&type=template&id=28646724&scoped=true"
import script from "./BankSlip.vue?vue&type=script&lang=js"
export * from "./BankSlip.vue?vue&type=script&lang=js"
import style0 from "./BankSlip.vue?vue&type=style&index=0&id=28646724&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28646724",
  null
  
)

export default component.exports